import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getReviews = createAsyncThunk(
    'kitchenReviews/getReviews',
    async (data, { rejectWithValue }) => {
        const api = '/kitchens/getReviews?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return {
                items: response.data.data.reviews.reviews,
                total: response.data.data.reviews.pagination.total,
            };
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getReviewsStatus: null,
    reviews: [],
    currentPage: 1,
    total: 0,
};

const kitchenReviewsSlice = createSlice({
    name: 'kitchenReviews',
    initialState,
    extraReducers: (builder) => {
        builder
            // getReviews
            .addCase(getReviews.pending, (state) => { state.getReviewsStatus = 'pending'; })
            .addCase(getReviews.fulfilled, (state, action) => { 
                state.getReviewsStatus = 'fulfilled'; 
                state.reviews = action.payload?.items || []; 
                state.total = action.payload?.total || 0; 
            })
            .addCase(getReviews.rejected, (state) => { state.getReviewsStatus = 'rejected'; })

            // PURGE
            .addCase(PURGE, () => { return initialState; });
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
});

export const {
    setCurrentPage,
} = kitchenReviewsSlice.actions;

export default kitchenReviewsSlice.reducer;
